<template>

    <v-row
        no-gutters
        class="event__block"
    >
      <v-col class="event__block_logo" v-if="item.card_image"
             :style="item.card_image ? {'background-image': `url('${getFileLink(item.card_image.link)}')`}: {}"
             style="background-size: cover; background-position: center;background-repeat: no-repeat; border-radius: 5px 0 0 5px">
        <div class="event__block_logo--title">
          {{ item.title }}
          <v-btn
            v-if="item.is_registration_available && !item.iam_participants"
            :color="'#376FFE'"
            width="110"
            height="25"
            elevation="0"
            class="event__block_btn mt-2"
            @click.stop="modal.register = true"
          >
            Записаться
          </v-btn>
          <v-btn
            v-else-if="item.is_registration_available && item.iam_participants"
            color="#FFC538"
            width="110"
            height="25"
            elevation="0"
            class="event__block_btn mt-2"
            style="color: black"
            @click.stop="modal.cancel = true"
          >
            Отменить<v-icon v-if="item.is_registration_available" style="color: red" size="16px">history_2</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col class="event__block_text">

        <v-container class="fill-height align-stretch">
          <div class="event__card_tag" v-if="item.tags && item.tags.length > 0" @click.stop="$emit('changeTag', item.tags[0].id)">
            {{ item.tags[0].name }}
          </div>
<!--          <v-row><v-col>{{ item.title }}</v-col></v-row>-->
          <v-row style="width: 100%" :class="{'pt-6': item.tags && item.tags.length > 0}">
            <v-col>{{ item.short_description }}</v-col>
          </v-row>
          <v-row style="width: 100%">
            <v-col class="">
              <div
                class="event__block_code--usage"
              >
                {{convertDate(item.event_date)}}
                <span v-if="item.is_registration_available">[{{ item.participants.registered }}({{ item.participants.total }})/{{ item.max_participants }}]</span>
              </div>
            </v-col>
            <v-col>
              <div
                class="event__block_code--date"
              >
                {{ item.partner_info.name }}
              </div>
            </v-col>
            <v-col>
              <v-btn
                :color="'#376FFE'"
                width="110"
                height="25"
                elevation="0"
                :class="'event__block_btn'"
                @click.stop="getDetail(item)"
              >
                Подробнее
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <user-register-application
        v-model="modal.register"
        :event_id="item.id"
        v-if="item.is_registration_available"
        @save="registerToEvent($event, 'register')"
        @close="closeRegisterToEvent('register')"
      ></user-register-application>
      <user-cancel-register-application
        v-model="modal.cancel"
        :event_id="item.id"
        :app_id="item.iam_participant_id"
        v-if="item.is_registration_available"
        @save="registerToEvent($event, 'cancel')"
        @close="closeRegisterToEvent('cancel')"
      ></user-cancel-register-application>
    </v-row>

</template>

<script>
import { defineComponent } from 'vue'
import UserRegisterApplication from "@/modules/personal_account/calendar/modals/UserRegisterApplication.vue"
import UserCancelRegisterApplication from "@/modules/personal_account/calendar/modals/UserCancelRegisterApplication.vue"
import helper from "@/urls/helper"
import names from "@/modules/personal_account/routers/names"
import moment from "moment"

export default defineComponent({
  name: "EventCard",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    justify_row: {
      type: String,
      default: 'start'
    }
  },
  components: { UserRegisterApplication, UserCancelRegisterApplication },
  data () {
    return {
      covers: {},
      modal: {
        register: false,
        cancel: false
      }
    }
  },
  methods: {
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    getDetail (item) {
      this.$router.push({ name: names.CALENDAR.DETAIL, params: { id: item.id } })
    },
    convertDate (value) {
      return moment(value).format('YYYY-MM-DD HH:mm')
    },
    registerToEvent (ev, modal) {
      this.$emit('singup', ev)
      this.modal[modal] = false
    },
    closeRegisterToEvent (modal) {
      this.modal[modal] = false
    }
  },
  beforeRouteLeave () {
    if (window.scrollY !== 0) {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
})
</script>

<style scoped lang="scss">
.event__content {
  padding: 50px 50px 0;

  &:last-child {
    padding-bottom: 50px;
  }
}

.event__block {
  min-height: 176px;
  //height: 176px;
  box-sizing: border-box;
  //border: 1px dashed rgba(49, 55, 67, 1);
  filter: drop-shadow(1px 1px 10px rgba(52, 52, 124, 0.1));
  border-radius: 5px;
  box-shadow: 1px 1px 10px 0 rgba(52, 52, 124, 0.1);
}

.event__block_logo {
  max-width: 29.9%;
  display: inline-flex;
  //flex-direction: column;
  justify-content: center;
  //align-items: start;
  align-items: center;

  &--title {
    margin-left: 20px !important;
    margin-right: 20px !important;
    padding: 10px 5px;
    //background: rgba(211, 211, 211, 0.85);
    background: rgba(236, 239, 251, 0.9);
    border-radius: 5px;
    border: rgba(0, 0, 0, 0.5) solid 1px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    //color: black;
    color: #3254B9;
  }
}

.event__block_text {
  //max-width: 48.5%;
  padding-inline: 30px 30px !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #313743;
}

.event__block_code {
  //max-width: 29.9%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-left: 1px dashed rgba(49, 55, 67, 1);

  &--title {
    padding-top: 5px;
    padding-bottom: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    //color: black;
    color: #3254B9;
  }

  &--usage {
    height: 20px;
    padding-top: 4px;
    //margin-bottom: 10px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: #3254B9;
  }

  &--number {
    margin: 20px 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 212px;
    height: 40px;
    background-color: #ECEFFB;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #313743;
  }

  &--cover {
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
  }

  &--date {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    padding-top: 4px;
    height: 20px;
    text-align: center;
    color: #959595;
  }
}

.event__card_tag {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  max-width: 220px;
  padding: 0 10px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
}

.event__block_btn {
  border-radius: 25px;
  color: white;
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 11px;
  line-height: 15px;

  &.copy {
    color: #376FFE;
    border: 1px solid #376FFE;
  }

  &.annul {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 25px;
  }
}

@media screen and (min-width: 961px) and (max-width: 1280px) {
  .event__block_logo {
    padding-left: 20px !important;
  }
}

@media screen and (max-width: 960px) {
  .event__content {
    padding: 0 0 50px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .event__block {
    height: 371px;
  }

  .event__block_logo {
    margin-top: 10px;
    margin-bottom: 10px;
    height: 100px;
    width: 100%;
    max-width: 100%;
    min-width: 560px;
  }

  .event__block_text {
    margin-bottom: 10px;
    width: 100%;
    height: 79px;
    max-width: 100%;
    min-width: 560px;
    padding-inline: 20px 20px !important;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }

  .event__block_code {
    width: 100%;
    height: 162px;
    max-width: 100%;
    min-width: 560px;
    border-left: none;
    border-top: 1px dashed rgba(49, 55, 67, 1);
  }
}

@media screen and (max-width: 768px) {
  .event__content {
    padding: 0 0 20px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .event__block_logo {
    min-width: 420px;
  }

  .event__block_text {
    min-width: 420px;
  }

  .event__block_code {
    min-width: 420px;
  }
}

@media screen and (max-width: 600px) {
  .event__block_logo {
    min-width: 330px;
  }

  .event__block_text {
    min-width: 330px;
  }

  .event__block_code {
    min-width: 330px;
  }
}

@media screen and (max-width: 428px) {
  .event__block_logo {
    min-width: 290px;
  }

  .event__block_text {
    min-width: 290px;
  }

  .event__block_code {
    min-width: 290px;
  }
}

@media screen and (max-width: 369px) {
  .event__block_logo {
    min-width: 220px;
    padding: 0 10px !important;
  }

  .event__block_text {
    min-width: 220px;
  }

  .event__block_code {
    min-width: 220px;
  }
}
</style>
